var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin2Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_6906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 19.7731L4.69667 14.4698C3.64779 13.4209 2.93349 12.0845 2.64411 10.6296C2.35473 9.17479 2.50326 7.6668 3.07092 6.29636C3.63858 4.92592 4.59987 3.75458 5.83324 2.93048C7.0666 2.10637 8.51665 1.6665 10 1.6665C11.4834 1.6665 12.9334 2.10637 14.1668 2.93048C15.4001 3.75458 16.3614 4.92592 16.9291 6.29636C17.4968 7.6668 17.6453 9.17479 17.3559 10.6296C17.0665 12.0845 16.3522 13.4209 15.3033 14.4698L10 19.7731ZM14.125 13.2914C14.9408 12.4756 15.4963 11.4362 15.7213 10.3047C15.9463 9.17313 15.8308 8.00027 15.3892 6.9344C14.9477 5.86854 14.2 4.95753 13.2408 4.31658C12.2815 3.67563 11.1537 3.33353 10 3.33353C8.8463 3.33353 7.71851 3.67563 6.75924 4.31658C5.79997 4.95753 5.05229 5.86854 4.61076 6.9344C4.16923 8.00027 4.05368 9.17313 4.27871 10.3047C4.50374 11.4362 5.05926 12.4756 5.875 13.2914L10 17.4164L14.125 13.2914ZM10 10.8331C9.55798 10.8331 9.13405 10.6575 8.82149 10.345C8.50893 10.0324 8.33334 9.60847 8.33334 9.16644C8.33334 8.72441 8.50893 8.30049 8.82149 7.98793C9.13405 7.67537 9.55798 7.49977 10 7.49977C10.442 7.49977 10.866 7.67537 11.1785 7.98793C11.4911 8.30049 11.6667 8.72441 11.6667 9.16644C11.6667 9.60847 11.4911 10.0324 11.1785 10.345C10.866 10.6575 10.442 10.8331 10 10.8331Z",
    fill: "#17428B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_6906"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin2Line);
export default __webpack_public_path__ + "static/media/map-pin-2-line.2c1939e87ee094d8bd03fbf21130cb84.svg";
export { ForwardRef as ReactComponent };